<!--
 * @Description: 费用查缴
--> 
<template>
  <div class="fee-pay">
    <van-nav-bar :title="$route.meta.title" fixed>
      <template #left>
        <span @click="$comm.onClickLeft" class="iconfont iconshang comm-rotate-270"></span>
        <span @click="$comm.onClickLeft" class="comm-return">返回</span>
      </template>
      <template #right>
        <div style="width:20px;height:20px" @touchstart="showDeleteButton()" @touchend="emptyTime"></div>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <van-swipe-cell>
          <div class="comm-seperator"></div>
          <div v-show="active===0" class="tab-content">
            <div class="comm-search-bar">
              <div class="bar-con">
                <van-field label="用户号" placeholder="" readonly clickable name="picker" :value="value" @click="toShowPicker">
                  <template #right-icon>
                    <span class="iconfont iconxuanzesanjiao"></span>
                  </template>
                </van-field>
              </div>
            </div>
            <div v-for="(item, i) in feeList" :key="i">
              <fee-pay-item :ParentPage="'FeePay'" :item="item"></fee-pay-item>
              <div class="comm-seperator"></div>
            </div>
            <div v-if="feeList.length===0" style="text-align:center;">
              <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
            </div>
          </div>
          <div v-show="active===1" class="tab-content">
            <div class="comm-search-bar">
              <div class="bar-con">
                <van-field label="用户号" placeholder="" readonly clickable name="picker" :value="value" @click="toShowPicker">
                  <template #right-icon>
                    <span class="iconfont iconxuanzesanjiao"></span>
                  </template>
                </van-field>
              </div>
            </div>
            <div v-for="(item, i) in sewageList" :key="i">
              <sewage-pay-item :item="item"></sewage-pay-item>
              <div class="comm-seperator"></div>
            </div>
            <div v-if="sewageList.length===0" style="text-align:center;">
              <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
            </div>
          </div>
          <!-- <div v-show="active===2"
						class="tab-content">
						<div v-for="(item, i) in projectList"
							:key="i">
							<project-pay-item :item="item" @requery="getProjectFee"></project-pay-item>
							<div class="comm-seperator"></div>
						</div>
						<div v-if="projectList.length===0"
							style="text-align:center;">
							<img style="width:200px;"
								:src="require('../../assets/images/no-data.png')">
						</div>
					</div> -->
          <div v-show="active===2" class="tab-content">
            <div class="search-bar">
              <div class="bar-con">
                <van-field required style="width:100%;" v-model="userno" label="用户号" placeholder="" />
                <!-- <van-field style="width:49%;" v-model="mobile" label="手机号码" placeholder="" /> -->
              </div>
              <div class="bar-btn" @click="getQueryFee()">
                查询
              </div>
            </div>
            <div class="user-list" v-for="(item, i) in queryList" :key="i">
              <fee-pay-item :ParentPage="'FeePay'" :item="item"></fee-pay-item>
            </div>
            <div class="comm-seperator"></div>
            <div style="text-align:center;" v-if="queryList.length==0">
              <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
            </div>
          </div>
        </van-swipe-cell>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
    <div class="comm-homebar-height"></div>
    <home-bar v-show="$debugStart"></home-bar>
    <van-dialog v-model="validateShow" title="标题" @confirm="pwdConfirm" show-cancel-button>
      <van-field v-model="pwd2" autosize label="管理员认证" />
    </van-dialog>
  </div>
</template>

<script>
import HomeBar from "@/components/HomeBar.vue";
import FeePayItem from "./FeePayItem";
import SewagePayItem from "./SewagePayItem";
// import ProjectPayItem from "./ProjectPayItem";
export default {
  name: "FeePay",
  components: {
    HomeBar,
    FeePayItem,
    SewagePayItem,
    // ProjectPayItem
  },
  data() {
    return {
      Loop: null,
      // debugStart: true,
      validateShow: false,
      pwd2: '',
      pwd1: 'hdkj',
      queryList: [],
      feeList: [],
      sewageList: [],
      projectList: [],
      userno: "",
      mobile: "",
      active: 0,
      tabs: [
        {
          title: "水费缴纳"
        },
        {
          title: "污水费缴纳"
        },
        // {
        // 	title: "工程费缴纳"
        // },
        {
          title: "户号查缴"
        }
      ],
      value: "全部",
      showPicker: false,
      columns: []
    };
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active);
    }
    this.onChange(this.active)
  },
  methods: {
    getUserList() {
      this.columns = []
      this.value = '全部'
      this.$http
        .post(this.$api.userList, {
          typeid: this.active + 1
        })
        .then(res => {
          if (res.code === "000") {
            this.columns = ["全部"].concat(res.data.map(e => e.userno));
          } else if (res.code === "003") {
            localStorage.clear()
            this.$toast('token失效，请重新进入此页面');
          }
        });
    },
    pwdConfirm() {
      if (this.pwd1 === this.pwd2) {
        this.$debugStart = true
      }
    },
    showDeleteButton: function () {
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(function () {
        this.validateShow = true
      }.bind(this), 3000);
    },
    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },
    onChange(value) {
      this.getUserList()
      if (value === 0) {
        this.getWaterFee();
      } else if (value === 1) {
        this.getSewageFee();
      } else if (value === 2) {
        this.getProjectFee();
      }
    },
    getWaterFee() {
      this.$http
        .post(this.$api.waterFee, {
          typeid: "1",
          userno: this.value == "全部" ? "" : this.value
        })
        .then(res => {
          if (res.code === "000") {
            this.feeList = res.data;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    getSewageFee() {
      this.$http
        .post(this.$api.sewageFee, {
          typeid: "2",
          userno: this.value == "全部" ? "" : this.value
        })
        .then(res => {
          if (res.code === "000") {
            this.sewageList = res.data;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    getProjectFee() {
      this.$http
        .post(this.$api.projectFee, {
          status: 0
        })
        .then(res => {
          if (res.code === "000") {
            if (res.data) {
              this.projectList = res.data;
            }
          } else {
            this.$toast(res.msg);
          }
        });
    },
    getQueryFee() {
      if (this.userno) {
        this.$loading("查询中");
        this.$http
          .post(this.$api.queryFee, {
            userno: this.userno,
            mobile: this.mobile
          })
          .then(res => {
            this.$clear();
            if (res.code === "000") {
              if (res.data) {
                this.queryList = res.data;
              }
            } else {
              this.$toast(res.msg);
            }
          });
      } else {
        this.$toast("请填入用户号");
      }
    },
    toShowPicker() {
      this.showPicker = true;
    },
    onConfirm(e) {
      this.value = e;
      this.showPicker = false;
      switch (this.active) {
        case 0:
          this.getWaterFee();
          break;
        case 1:
          this.getSewageFee();
          break;
      }
    }
  },
  watch: {
    active() {
      this.$http
        .post(this.$api.userList, {
          typeid: this.active + 1
        })
        .then(res => {
          this.columns = ["全部"].concat(res.data.map(e => e.userno));
        });
    }
  }
};
</script>

<style lang="less" scoped>
.fee-pay {
  .tab-content {
    .search-bar {
      background: rgba(255, 255, 255, 1);
      padding: 0 16px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bar-con {
        width: calc(~"100% - 64px");
        display: flex;
        justify-content: space-between;
        /deep/.van-field__body {
          padding: 0 7px;
        }
        /deep/.van-cell--required::before {
          left: -8px;
        }
      }
      .bar-btn {
        width: 64px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2c82c9;
        line-height: 40px;
      }
      /deep/.van-cell.van-field {
        padding: 0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(33, 33, 33, 1);
        .van-cell__title.van-field__label {
          width: 48px;
        }
        .van-cell__value.van-field__value {
          width: 90px;
          height: 27px;
          background: #f4f4f4;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>